import { useMe } from '@/hooks/api/0050_me';
import { Navigate } from 'react-router-dom';
import { useEffect } from 'react';

type Props = { children?: React.ReactNode };

export const RequireSignIn = (props: Props) => {
  const { data: me, status, error } = useMe();

  useEffect(() => {
    if (me) {
      // @ts-ignore
      window.Intercom('boot', {
        app_id: 'i2i99qtf',
        email: me.email,
        user_id: me.id,
        name: me.name,
      });
      // @ts-ignore
      window.Intercom('update');
    }
  }, [me]);

  if (status == 'error') {
    return <Navigate replace to={'/sign_in'} />;
  }

  if (status == 'success') {
    return <>{props.children}</>;
  }

  return <></>;
};
